import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { useClearingUploadData } from './useClearingUploadData';

export type EcuadorInfoProviders = 'interdin' | 'guayaquil' | 'pacific';

interface Option {
  label: string;
  value: EcuadorInfoProviders;
  disabled?: boolean;
}

const selectOptions = (translateFunction: TFunction): Option[] => [
  {
    label: translateFunction('clearings:infoProvidersSelector:selectInfoProvider'),
    value: '' as EcuadorInfoProviders,
    disabled: true
  },
  {
    label: translateFunction('clearings:infoProvidersSelector:interdin:label'),
    value: translateFunction('clearings:infoProvidersSelector:interdin:value')
  },
  {
    label: translateFunction('clearings:infoProvidersSelector:guayaquil:label'),
    value: translateFunction('clearings:infoProvidersSelector:guayaquil:value')
  },
  {
    label: translateFunction('clearings:infoProvidersSelector:pacific:label'),
    value: translateFunction('clearings:infoProvidersSelector:pacific:value')
  }
];

const infoProviderFileInfo: Record<EcuadorInfoProviders, Record<string, string>> = {
  guayaquil: {
    extensions: '.html',
    documentType: 'payments',
    fileName: 'manual_clearing_upload.html'
  },
  interdin: {
    extensions: '.txt',
    documentType: 'electronic_anticipations',
    fileName: 'manual_clearing_upload.txt'
  },
  pacific: {
    extensions: '.csv',
    documentType: 'payments',
    fileName: 'manual_clearing_upload.csv'
  }
};

export function useClearingUploadScreen() {
  const { t } = useTranslation();
  const [infoProviderSelected, setInfoProviderSelected] = useState<EcuadorInfoProviders>(
    '' as EcuadorInfoProviders
  );

  const [fileName, setFileName] = useState('');
  const [showModal, setShowModal] = useState(false);

  const { addFiles, fileUploaded } = useClearingUploadData();

  const toggleShowFilesFormatModal = () => {
    setShowModal((prevValue) => !prevValue);
  };

  return {
    addFiles,
    fileName,
    fileUploaded,
    infoProviderFileInfo,
    infoProviderSelected,
    selectOptions: selectOptions(t),
    setFileName,
    setInfoProviderSelected,
    toggleShowFilesFormatModal,
    showModal,
    t
  };
}
